<template>
  <div>
    <PageHeader :title="title" :items="items">
      <!-- <i class="bx bxs-help-circle font-size-20 div-clickable" @click="iniciarTour()"></i> -->
    </PageHeader>
    <div class="row col-md-12">
      <b-card data-v-step="1">
        <div class="row">
          <b-form-group label="Região" class="col-md-3 mb-3">
            <b-form-input
              :value="
                rdvInfo.cidade_uf_movimento
                  ? rdvInfo.cidade_uf_movimento
                  : rdvInfo.nm_localidade
              "
              disabled
            />
          </b-form-group>

          <b-form-group
            label="Estabelecimento"
            class="col-md-3 mb-3'"
            v-if="rdvInfo.ds_carteira == 'Visa'"
          >
            <b-form-input v-model="rdvInfo.estabelecimento_visa" disabled />
          </b-form-group>
          <b-form-group
            label="Estabelecimento"
            class="col-md-3 mb-3'"
            v-if="rdvInfo.ds_carteira == 'Mastercard'"
          >
            <b-form-input
              v-model="rdvInfo.estabelecimento_mastercard"
              disabled
            />
          </b-form-group>
          <b-form-group
            label="Estabelecimento"
            class="col-md-3 mb-3'"
            v-if="rdvInfo.ds_carteira == 'Good Card'"
          >
            <b-form-input v-model="rdvInfo.estabelecimento_frota" disabled />
          </b-form-group>

          <b-form-group label="Data Transação" class="col-md-3 mb-3'">
            <b-form-input
              :value="$tools.converteData(rdvInfo.dt_lancamento)"
              disabled
            />
          </b-form-group>
          <b-form-group label="Valor Transação" class="col-md-3 mb-3'">
            <b-form-input
              :value="$tools.converteReal(rdvInfo.vl_original)"
              disabled
            />
          </b-form-group>
        </div>

        <div class="row">
          <b-form-group
            label="Motivo da falta de comprovação"
            class="col-md-12 mb-3"
            :state="state('motivo')"
          >
            <multiselect
              placeholder="Selecione"
              v-model="motivo"
              :show-labels="false"
              :allow-empty="false"
              :options="optionMotivos"
              label="ds_transacao_motivo_falta"
            />
          </b-form-group>
        </div>

        <div class="row">
          <b-form-group
            label="Justificativa da falta de comprovação"
            label-for="Justificativa"
            class="col-12"
          >
            <b-form-textarea
              for="Justificativa"
              v-model="justificativaCooperado"
              placeholder="Justificativa"
              :maxlength="200"
              :state="state('justificativaCooperado')"
            ></b-form-textarea>
            <div class="text-center">
              <p
                v-if="justificativaCooperado"
                class="badge position-absolute"
                :class="{
                  'bg-success': justificativaCooperado.length !== 200,
                  'bg-danger': justificativaCooperado.length === 200,
                }"
              >
                {{ justificativaCooperado.length }} / 200
              </p>
            </div>
          </b-form-group>
        </div>

        <div class="row">
          <div class="d-flex justify-content-end px-1 mt-3">
            <div class="me-2 align-self-center mt-1">
              <router-link to="/cooperado/rdv">
                <b-button class="btn-lg"> Voltar </b-button>
              </router-link>
            </div>
            <div class="me-2 align-self-center mt-1">
              <b-button
                @click="incluirJustificativa()"
                class="btn-lg"
                variant="primary"
                :disabled="loading"
              >
                Salvar
                <b-spinner small class="ms-2" v-if="loading"></b-spinner>
              </b-button>
            </div>
          </div>
        </div>
      </b-card>
      <!-- <v-tour name="tourListaAdiantamento" :steps="stepsTour" :options="tourOptions" :callbacks="tourCallbacks"></v-tour> -->
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  components: {
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Justificar Falta de Comprovação de Despesa",
      items: [
        {
          text: "RDV4.0",
        },
        {
          text: "Justificar Falta de Comprovação de Despesa",
          active: true,
        },
      ],
      motivo: "",
      optionMotivos: [],
      justificativaCooperado: "",
      rdvInfo: {},
      loading: false,
      submit: false,
    };
  },
  validations: {
    justificativaCooperado: {
      required,
      maxLength: minLength(30),
    },
    motivo: {
      required,
    },
  },
  created() {
    if (this.$store.state.rdvCooperado) {
      this.rdvInfo = this.$store.state.rdvCooperado.item;
      this.items.splice(1, 0, { text: this.rdvInfo.cd_rdv });
      this.buscarMotivos();
    } else {
      this.$router.push("/cooperado/rdv");
    }
    window.scrollTo(0, 0);
  },
  methods: {
    state(param) {
      if (this.submit) {
        return !this.$v[param].$invalid;
      } else {
        return null;
      }
    },
    buscarMotivos() {
      this.$http
        .get("api/rdvCooperado/justificativa/buscarMotivos")
        .then((response) => {
          this.optionMotivos = response.data;
          if (this.rdvInfo.sq_transacao_motivo_falta) {
            this.motivo = this.optionMotivos.find(
              (el) =>
                el.sq_transacao_motivo_falta ==
                this.rdvInfo.sq_transacao_motivo_falta
            );
            this.justificativaCooperado = this.rdvInfo.ds_justificativa_falta;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async incluirJustificativa() {
      this.loading = true;
      this.submit = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (this.justificativaCooperado.length < 30) {
          this.$tools.alerta(
            "Justificativa tem que ter no minimo 30 caracteres.",
            "error"
          );
        } else {
          this.$tools.alerta(
            "Preencha os campos obrigatórios em vermelho.",
            "error"
          );
        }
        this.loading = false;
        return;
      }
      try {
        await this.$tools.filtroCooperado.incluirMotivoFalta(
          this.rdvInfo,
          this.motivo,
          this.justificativaCooperado
        );
        this.loading = false;
        this.$store.commit("ENVIAR_NOTIFICACAO", {
          notificacao: "Cadastro com sucesso",
          icone: "success",
        });
        this.$router.push("/cooperado/rdv");
      } catch (err) {
        this.$tools.alerta("Erro ao efetuar cadastro", "error");
        console.log(err);
        this.loading = false;
      }
    },
  },
};
</script>